import { Select } from '@mantine/core';
import classNames from 'theme/components/Combobox/Select/Select.module.css';

export default Select.extend({
  classNames,
  defaultProps: {
    variant: 'primary',
  },
});
